import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'

const WebhookProfileSetup = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Adding new webhook profile allows you to integrate with external notification app.
    </Color>
    <DocusaurusFooter path={daiWebhooks} />
  </Paragraph>

export default WebhookProfileSetup
